import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { ThemeProvider } from "./lib/theme.tsx";
import "./styles/styles.css";
import "./styles/docs-extra.css";
// theme.css depois dos dois anteriores: ele reaponta regras de mesma
// especificidade, então precisa vir por último entre as folhas de cor.
import "./styles/theme.css";
import "./styles/motion.css";

// Falhar aqui é melhor do que renderizar no vazio: sem #root o site não existe,
// e o `!` esconderia isso atrás de um erro do React lá adiante.
const root = document.getElementById("root");
if (!root) throw new Error("index.html sem #root: nada onde montar a aplicação.");

// As flags `future` (v7_startTransition, v7_relativeSplatPath) saíram junto com
// o react-router 7: eram o modo de adotar o comportamento da v7 ainda na v6, e
// agora são o padrão. Passá-las hoje é prop inexistente.
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Avisa o splash do index.html que já há conteúdo pintado.
//
// Dois rAF, não um: o primeiro roda antes do paint que o React acabou de
// agendar, e o segundo depois dele. Com um só, o splash sairia revelando a
// página ainda em branco — o flash que ele existe para evitar.
requestAnimationFrame(() => requestAnimationFrame(() => window.dispatchEvent(new Event("app-ready"))));
